export default __webpack_public_path__ + "3f49af0c49370bee1b2599f20771e410.svg";